// import packageInfo from '../../package.json';

export const environment = {
  // appVersion: packageInfo.version,
  production: false,
  appVersion: 1,
  apiUrlLabelTraxxService: 'https://qc7wu088a6.execute-api.us-east-1.amazonaws.com/dev',
  ltTemplateProduct: '70628',
  intouchArtworkBucket: 'intouch.artwork.dev'
};
